var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcBlik = function SvgIcBlik(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "21px",
    viewBox: "0 0 40 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web_p\\u0142atno\\u015B\\u0107_klient_supskrypcja",
    transform: "translate(-754.000000, -658.000000)",
    fill: "#DADADA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(110.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(478.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(166.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80963311,1.6225 L3.80963311,8.71 C4.69625588,8.2375 5.68718721,7.975 6.78242709,7.975 C10.2246096,7.975 12.9887865,10.81 12.9887865,14.2225 C12.9887865,17.6875 10.2246096,20.5225 6.78242709,20.5225 C3.34024459,20.5225 0.523913452,17.6875 0.523913452,14.2225 L0.523913452,14.2225 L0.523913452,1.6225 L3.80963311,1.6225 Z M18.5692944,1.6225 L18.5692944,20.365 L15.2835748,20.365 L15.2835748,1.6225 L18.5692944,1.6225 Z M24.7756538,8.1325 L24.7756538,20.365 L21.4899341,20.365 L21.4899341,8.1325 L24.7756538,8.1325 Z M39.2745437,8.1325 L34.6849671,13.75 L39.7960865,20.365 L35.5715898,20.365 L30.9298589,13.8025 L35.4672813,8.1325 L39.2745437,8.1325 Z M30.9298589,1.6225 L30.9298589,20.365 L27.6441392,20.365 L27.6441392,1.6225 L30.9298589,1.6225 Z M6.78242709,11.23 C5.11349012,11.23 3.75747883,12.595 3.75747883,14.2225 C3.75747883,15.9025 5.11349012,17.2675 6.78242709,17.2675 C8.39920978,17.2675 9.75522107,15.9025 9.75522107,14.2225 C9.75522107,12.595 8.39920978,11.23 6.78242709,11.23 Z M10.0681468,0.6775 C11.6849294,0.6775 12.9887865,2.0425 12.9887865,3.67 C12.9887865,5.2975 11.6849294,6.61 10.0681468,6.61 C8.45136406,6.61 7.14750706,5.2975 7.14750706,3.67 C7.14750706,2.0425 8.45136406,0.6775 10.0681468,0.6775 Z",
    id: "logo-blik"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBlik, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_blik.997d597a.svg";
export { ForwardRef as ReactComponent };